import { Injectable } from '@angular/core'
import { UserInfo } from '../../models/userModels'
@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  public currentUserInfo: UserInfo

  private handleError(error: Response | any) {
    let errMsg: string
    if (error instanceof Response) {
      const body = error.json() || ''
      const err = body || JSON.stringify(body)
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`
    } else {
      errMsg = error.message ? error.message : error.toString()
    }
    return Promise.reject(errMsg)
  }
}
